// removed by extract-text-webpack-plugin
module.exports = {"container":"Notifications__container___21zEM","border":"Notifications__border___3-3OA"};